import { Injectable } from '@angular/core';
import {LazyLoadEvent} from "primeng/api";
import {isNullOrUndefined} from "util";

@Injectable()
export class TableParserService {

  constructor() { }

  parse(event: LazyLoadEvent){
    //console.log(event);
    let filters = Object.keys(event.filters).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(event.filters[key].value)}`);
    let page = `page=${event.first/event.rows+1}`;
    let size = `size=${event.rows}`;
    let sortOrder = ((event.sortOrder>0) ? 'asc' : 'desc');
    let sort = ((!isNullOrUndefined(event.sortField)) ? `sort=${encodeURIComponent(event.sortField)},${sortOrder}` : '');

    filters.push(page);
    filters.push(size);
    filters.push(sort);

    return filters.join('&')
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/table-parser.service.ts